// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorOrders = (client) => ({
    /**
     * `POST /vendor/orders/:id/cancel`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorCancelOrder
     * @source packages/modules/b2c-core/src/api/vendor/orders/[id]/cancel/route.ts
     */
    cancel: (id, body, query, headers) => client.fetch(buildPath("/vendor/orders/:id/cancel", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/orders/:id/fulfillments/:fulfillment_id/cancel`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorCancelOrderFulfillment
     * @source packages/modules/b2c-core/src/api/vendor/orders/[id]/fulfillments/[fulfillment_id]/cancel/route.ts
     */
    cancelFulfillments: (id, fulfillmentId, body, query, headers) => client.fetch(buildPath("/vendor/orders/:id/fulfillments/:fulfillment_id/cancel", [id, fulfillmentId]), { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/orders/:id/complete`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorCompleteOrder
     * @source packages/modules/b2c-core/src/api/vendor/orders/[id]/complete/route.ts
     */
    complete: (id, body, query, headers) => client.fetch(buildPath("/vendor/orders/:id/complete", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/orders/:id/fulfillments`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorCreateFulfillment
     * @source packages/modules/b2c-core/src/api/vendor/orders/[id]/fulfillments/route.ts
     */
    createFulfillment: (id, body, query, headers) => client.fetch(buildPath("/vendor/orders/:id/fulfillments", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/orders/:id/fulfillments/:fulfillment_id/shipments`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorUpdateOrderFulfillmentShipment
     * @source packages/modules/b2c-core/src/api/vendor/orders/[id]/fulfillments/[fulfillment_id]/shipments/route.ts
     */
    createFulfillmentsShipment: (id, fulfillmentId, body, query, headers) => client.fetch(buildPath("/vendor/orders/:id/fulfillments/:fulfillment_id/shipments", [id, fulfillmentId]), { method: "POST", body, query, headers }),
    /**
     * `GET /vendor/orders`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListOrders
     * @source packages/modules/b2c-core/src/api/vendor/orders/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/orders", { method: "GET", query, headers }),
    /**
     * `GET /vendor/orders/:id/changes`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListOrderChanges
     * @source packages/modules/b2c-core/src/api/vendor/orders/[id]/changes/route.ts
     */
    listChanges: (id, query, headers) => client.fetch(buildPath("/vendor/orders/:id/changes", [id]), { method: "GET", query, headers }),
    /**
     * `GET /vendor/orders/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetOrder
     * @source packages/modules/b2c-core/src/api/vendor/orders/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/vendor/orders/:id", [id]), { method: "GET", query, headers }),
    /**
     * `GET /vendor/orders/:id/auto-assign-sales-manager`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorOrdersIdAutoAssignSalesManagerRetrieve
     * @source packages/modules/b2c-core/src/api/vendor/orders/[id]/auto-assign-sales-manager/route.ts
     */
    retrieveAutoAssignSalesManager: (id, query, headers) => client.fetch(buildPath("/vendor/orders/:id/auto-assign-sales-manager", [id]), { method: "GET", query, headers }),
    /**
     * `GET /vendor/orders/:id/commission`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @source packages/modules/commission/src/api/vendor/orders/[id]/commission/route.ts
     */
    retrieveCommission: (id, query, headers) => client.fetch(buildPath("/vendor/orders/:id/commission", [id]), { method: "GET", query, headers }),
    /**
     * `POST /vendor/orders/:id/fulfillments/:fulfillment_id/mark-as-delivered`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorOrderFulfillmentMarkDelivered
     * @source packages/modules/b2c-core/src/api/vendor/orders/[id]/fulfillments/[fulfillment_id]/mark-as-delivered/route.ts
     */
    updateFulfillmentsMarkAsDelivered: (id, fulfillmentId, body, query, headers) => client.fetch(buildPath("/vendor/orders/:id/fulfillments/:fulfillment_id/mark-as-delivered", [id, fulfillmentId]), { method: "POST", body, query, headers }),
});
//# sourceMappingURL=orders.js.map